import React, {PureComponent} from 'react';

import TabNav from 'components/BarTab/TabNav';

import styles from './styles';

export default class BarTab extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selected: null,
      tabs: []
    };
  }

  onTabClicked = ({ target: { id } }) => {

    if (id) {
      this.setState({
        selected: id
      });
    }
  };

  componentDidMount() {
    const {initial, children} = this.props;
    const childrenArray = React.Children.toArray(children);
    const tabs = childrenArray.filter(child => child.type.displayName === 'Tab');
    let selected = childrenArray[0].props.id;

    if (initial) {
      selected = initial;
    }

    this.setState({
      selected,
      tabs
    });
  }

  render() {
    const {children, className} = this.props;
    const {selected, tabs} = this.state;

    const content = React.Children.toArray(children)
      .filter(child => child.type.displayName === 'TabContent')
      .filter(child => child.props.id === selected);

    return (
      <div className={`${styles.barTab} ${className}`}>
        <TabNav selected={selected} onClick={this.onTabClicked}>
          {tabs}
        </TabNav>
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BarTab/BarTab.jsx